<template>
	<div>
		<slot v-if="widgetLoad">
			<div class="tgju-widget-content full-padding">
				<div class="text-center p-2">
					<div class="widget-loading"></div>
				</div>
			</div>		
		</slot>
		<slot v-else>
			<div v-if="friends.items.data.length" class="w100w">
				<div v-for="friend in friends.items.data" :key="friend.id" class="follow-row"  style="display: block;">
					<div class="follow-row-item">
						<div class="follow-avatar">
							<img :src="friend.avatar ? ($helpers.api_url() + $helpers.json_pars(friend.avatar).name) : 'https://static.tgju.org/views/default/images/avatar.jpg'">
						</div>
						<div class="follow-title">
							<router-link :to="{ name: 'ProfileOthers', params: { username: friend.username }}">
								<h2>{{ friend.firstname +' '+ friend.lastname }}</h2>
							</router-link>
							<div class="register-date">
								<i class="uil uil-calendar-alt"></i>
								تاریخ عضویت : {{ toRelative(friend.created_at) }}						
							</div>
						</div>
						<div class="follow-content">
							<div class="follow-content-items">
								<h3><i class="uil uil-comment-alt-lines"></i> {{ friend.posts }} </h3>
							</div>
							<div class="follow-content-items">
								<h3><i class="uil uil-chart"></i> {{ friend.technicals }} </h3>
							</div>
							<div class="follow-content-items">
								<h3><i class="uil uil-thumbs-up"></i> {{ friend.likes }} </h3>
							</div>
						</div>
						
						<div class="follow-btns">
							<span v-if="friends_id.includes(friend.id)" class="tgju-btn tgju-btn-danger" @click.prevent="follow('unfollow',friend.username)">
								<i class="uil uil-times" aria-hidden="true"></i>عدم دنبال کردن
							</span>
							<span v-else-if="friend.username != $helpers.userInfo().username" class="tgju-btn tgju-btn-primary" @click.prevent="follow('follow',friend.username)">
								<i class="uil uil-user-plus" aria-hidden="true"></i>
								دنبال کردن
							</span>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="text-center p-2">
				یافت نشد !
			</div>

			<slot v-if="friends.last_page > 1">
				<paginate :page-count="friends.items.last_page" :click-handler="getFriends" :prev-text="'قبل'" :next-text="'بعد'" :container-class="'pagination'" ></paginate>
			</slot>
		</slot>
</div>
</template>

<style lang="scss" scoped>
	.widget-min-box-content {
		.l-title {
			display: flex;
		}

		.edit-note {
			font-size: 14px;
			cursor: pointer;
			margin-right: -3px;
		}
	}
</style>

<script>
	import moment from "moment-jalaali";
	import paginate from "vuejs-paginate";

	export default {
		name: 'ProfileOtherFollowingComp',
		props: ['username'],
		components: {
			paginate
		},
		data () {
			return {
				friends : {
					items : {
						data : {
							length : undefined,
						},
						current_page: undefined,
						from: undefined,
						last_page: undefined,
						next_page_url: undefined,
						per_page: undefined,
						prev_page_url: undefined,
						to: undefined,
						total: undefined,
					},
					current_friends_id : undefined
				},
				friends_id : undefined,
				currentRoute : this.$router.currentRoute.name,
				widgetLoad: true,
			}
		},
		mounted() {
			this.getFriends();
		},
			
		methods: {
			toRelative(date) {
				if (moment().diff(moment(date), 'days') < 30)
					return moment(date).fromNow();
				else
					return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
			},
			follow(action,username) {
				let api_data = {
					action: action,
				};

				this.$helpers.makeRequest('GET', '/user/follow/' + username , api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						this.getFriends();
					}

					if ( api_response.status == 400 ) {
						Vue.prototype.$toast.warn({
							title : 'توجه',
							message : 'شما پیش تر این کاربر را دنبال کرده اید'
						});
					}

				});
			},
			
			getFriends(page) {
				
				let api_data = {
					username : this.username,
					page : page ? page : 1,
				};

				this.$helpers.makeRequest('GET', '/user/friends/following', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);
					if ( api_response.data.response.status === 'success' ) {
						this.friends = api_response.data.response.detail;
						this.friends_id = this.friends.friends_id;
					}
					
					this.widgetLoad = false;
				});
			},
		}
	}
</script>